<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        @click.prevent="showOpciones= !showOpciones">
      <i :class="showOpciones ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpciones">
      <b-form>
        <b-form-group
          label="Desde"
          label-for="fechaDesde"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaDesde" 
            v-model= "filtro.fechaDesde" 
            type="date">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Hasta"
          label-for="fechaHasta"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="fechaHasta" 
            v-model= "filtro.fechaHasta" 
            type="date">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Cliente"
          label-for="cliente"
          :label-cols="labelCols"
          horizontal>
          <b-input-group>
            <b-input-group-append 
                class="filter-search-icons"
                v-if="!filtro.filtroNumero"
                @click="seleccionarCliente">
              <b-input-group-text>
                <i :class="{ 'fa fa-search': !filtro.cliente,
                              'fa fa-remove': filtro.cliente  }"></i>
              </b-input-group-text>
            </b-input-group-append>
            <b-form-input 
              id="cliente"
              :value="clienteNombre"
              readonly
              type="text"/>
          </b-input-group>
        </b-form-group>

        <div slot="footer">
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-form>
    </b-collapse>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </b-card>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import moment from 'moment';

export default {
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: false
    },
    cliente: {
      type: Object,
      default: null
    },
  },
  components: {
    appSearchCliente: SearchCliente,
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
      },

      showOpciones: Boolean(false),
      labelCols: 1
    }
  },
  created() {
    this.filtro.fechaDesde =  moment.utc(this.fechaDesde).format('YYYY-MM-DD');
    this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
    this.filtro.cliente = this.cliente;
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
  },
}
</script>

<style>
</style>
